module.exports = __webpack_public_path__ + "static/media/Dating_eng.706b6c6e.mp4";